
import request from '@/util/http'
import qs from 'qs'
const scope = 'server';


export const loginByUsername = (username, password, code, randomStr, key) => {
  const grant_type = 'password'

  return request({
    url: '/auth/oauth/token',
    method: 'get',
    params: { username, password, randomStr, code, grant_type, scope, key:randomStr ? randomStr : key }
  })
}
export const LoginWithoutPwd = (username) => {
  // const grant_type = 'password'
  return request({
    url: '/auth/mobile/token/social',
    method: 'post',
    params: { username }
  })
}
export const ssoLogin = (ticket) => {
  return request({
    url: '/auth/mobile/token/social?ticket='+ticket,
    method: 'post',
    data: {ticket},
    headers:{
      "ticket": ticket
    },
  })
}
// 一网通登录的时候需要单独加一个 params: {typeStr: true}，不然登录不上,
export const loginByUsernameSsO = (code) => {
    const str_data = qs.stringify({
        'grant_type' : 'maiyuesso',
        // 'client_id':'test',
        // 'client_secret':'test',
        'code': code,
    })
    return request({
        url: '/auth/oauth/token',
        method: 'post',
        params: {typeStr: true},
        // params: {randomStr, code, grant_type, scope },
        data: str_data
    })
}
export const loginCode = (randomStr) => {
  return request({
    url: '/code',
    method: 'get',
    params: randomStr
  })
}
export const userMissingMumber = (username) => {
  return request({
    url: '/user-missing-mumber',
    method: 'get',
    params: username
  })
}

export const refreshToken = (refresh_token) => {
  const grant_type = 'refresh_token'
  return request({
    url: '/auth/oauth/token',
    method: 'post',
    params: { refresh_token, grant_type, scope }
  })
}

export const loginByMobile = (mobile, code) => {
  const grant_type = 'mobile'
  return request({
    url: '/auth/mobile/token/sms',
    method: 'post',
    params: { mobile: 'SMS@' + mobile, code: code, grant_type }
  })
}

export const loginBySocial = (state, code) => {
  const grant_type = 'mobile'
  return request({
    url: '/auth/mobile/token/social',
    method: 'post',
    params: { mobile: state + '@' + code, grant_type }
  })
}

export const getUserInfo = () => {
  return request({
    url: '/admin/user/info',
    method: 'get'
  })
}

export const logout = () => {
  return request({
    url: '/auth/token/logout',
    method: 'delete'
  })
}


// 流程登录
export const bpmnSecurityLogin=(params)=>request(
    {
    headers:{
        "token": sessionStorage.getItem('nsdBpmToken') || '123'
    },
    url: `/admin/bpmn/security/login`,
    method: 'post',
    params
})
// // 南师大流程登录
// export const nsdBpmnSecurityLogin=(params)=>request(
//     {
//     headers:{
//       "token":  sessionStorage.getItem('nsdBpmToken') || '123'
//     },
//     url: `/admin/bpmn/security/login`,
//     method: 'post',
//     params
// })



// 短信验证码方式修改密码
export const resetPwdByCode=(data)=>request({
    headers:{
        "Content-Type": "application/json"
    },
    url: '/admin/personalCenter/resetPwdByCode',
    method: 'post',
    data:JSON.stringify(data)
})

// 短信获取验证码
export const sendPwdCode=(username)=>request({
    url: `/admin/mobile/sendPwdCode/${username}`,
    method: 'get',
})
// 电力手机获取验证码
export const sendPhoneCode=(username)=>request({
    url: `/admin/mobile/${username}`,
    method: 'get',
})

//手机验证码正常登录
export function saveLogin(query) {
    return request({
        url: "/auth/mobile/token/login",
        method: "post",
        params:query,
        headers:{
            "Authorization": 'Basic ZGxic2R0OjVATS4qLyk1cSQoLw=='
        },
    });
}

//获取系统配置参数信息
export const getLoginConfig = () =>
  request({
    url: `/admin/sys/loginConfig`,
    method: "get",
  });

// sso退出 回调地址
export const maiyuessoLogoutUrl = () =>
request({
  url: `/auth/token/pc/maiyuesso/logout`,
  method: "get",
});

// sso登录没有code 回调地址
export const maiyuessoAuthorizeUrl = () =>
  request({
    url: `/auth/token/pc/maiyuesso/authorizeUrl`,
    method: "get",
  });